/* eslint-disable react/prop-types */
import { Dialog, Transition } from "@headlessui/react"
import React, { Fragment, useState } from "react"

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

export default function MyModal(props) {
  const [isOpen, setIsOpen] = useState(false)
  const [state, setState] = React.useState({})
  const [sent, setSent] = React.useState(false)

  const openModal = () => {
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
  }

  const handleChange = (e) => {
    setState({ ...state, [e.target.name]: e.target.value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": form.getAttribute("name"),
        ...state,
      }),
    })
      .then(() => {
        setSent(true)
        setTimeout(() => {
          closeModal()
        }, 5000)
        setTimeout(() => {
          setSent(false)
        }, 6000)
      })
      .catch((error) => alert(error))
  }

  // console.log(props)

  return (
    <>
      <div className="inset-0 flex items-center justify-center w-full md:w-auto">
        <button
          type="button"
          onClick={openModal}
          className="m-4 tracking-[1.7px] py-5 px-12 border-2 uppercase font-bold border-slate-400 text-black bg-slate-300/10 text-[9px] text-center w-full md:w-64"
        >
          Bewertung hinzufügen
        </button>
        {/* This needs to be here to be rendered as HTML for Netlify to recognize the form */}
        <div hidden className="hidden">
          <form
            className="w-full text-sm text-gray-900"
            name="bewertung"
            method="post"
            action="/danke/"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            onSubmit={handleSubmit}
          >
            <input type="hidden" name="form-name" value="bewertung" />

            <p hidden>
              <label>
                Don’t fill this out:{" "}
                <input name="bot-field" onChange={handleChange} />
              </label>
            </p>
            <h5 className="mt-10">Persönliche Daten</h5>
            <div className="flex flex-wrap gap-4 mb-10">
              <label className="flex-auto flex flex-col w-32">
                <span className="block text-sm leading-5 text-gray-900">
                  Vorname
                </span>
                <input
                  name="vorname"
                  onChange={handleChange}
                  type="text"
                  className="text-sm h-8 "
                  required
                />
              </label>
              <label className="flex-auto flex flex-col w-32">
                <span className="block text-sm leading-5 text-gray-900">
                  Nachname
                </span>

                <input
                  name="nachname"
                  onChange={handleChange}
                  type="text"
                  className="text-sm h-8"
                  required
                />
              </label>
              <label className="flex-auto flex flex-col w-32">
                <span className="block text-sm leading-5 text-gray-900">
                  E-Mail
                </span>
                <input
                  name="email"
                  onChange={handleChange}
                  type="email"
                  className="text-sm h-8"
                  required
                />
              </label>
              <label className="flex-auto flex flex-col w-32">
                <span className="block text-sm leading-5 text-gray-900">
                  Telefonnummer
                </span>
                <input
                  name="telefon"
                  onChange={handleChange}
                  type="tel"
                  className="text-sm h-8"
                />
              </label>
            </div>
            <h5>Schreiben Sie eine Bewertung</h5>
            <div className="flex flex-wrap gap-4 mb-10">
              <label className="flex-auto flex flex-col w-32">
                <span className="block text-sm leading-5 text-gray-900">
                  Teilgenommene Reise
                </span>
                <input
                  name="reise"
                  onChange={handleChange}
                  type="text"
                  required
                  className="text-sm h-8"
                />
              </label>
              <label className="flex-auto flex flex-col w-64">
                <span className="block text-sm leading-5 text-gray-900">
                  Ihre Rezension
                </span>
                <textarea
                  name="rezension"
                  onChange={handleChange}
                  className="text-sm h-24"
                  placeholder="Schreiben Sie hier Ihre Rezension"
                />
              </label>
            </div>
            <div className="mt-4">
              <button
                className={`inline-flex justify-center px-4 py-2 text-[9px] uppercase font-bold tracking-[1.7px] text-black border bg-blue-100 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500
                    ${
                      props.typ == "wanderreise"
                        ? "bg-[#C4AC8B] bg-opacity-75 text-[#724C2D] border-2 border-[#A88A60]"
                        : props.typ == "segelkreuzfahrt"
                        ? "bg-blue-300 bg-opacity-75 text-blue-800 border-2 border-blue-900"
                        : "bg-[#CAD7B3] bg-opacity-75 text-[#6A9129] border-2 border-[#537235]"
                    }`}
                type="submit"
              >
                Abschicken
              </button>
            </div>
          </form>
        </div>
      </div>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="fixed inset-0 z-10 overflow-y-auto"
          onClose={closeModal}
        >
          <div className="min-h-screen px-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-black/30" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="inline-block h-screen align-middle"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl">
                <Dialog.Title
                  as="h3"
                  className="text-xl uppercase tracking-[1.7px] font-normal text-center"
                >
                  Bewertung schreiben
                </Dialog.Title>
                <div className="mt-8">
                  {sent ? (
                    <div>
                      <p>Vielen Dank für Deine Bewertung.</p>
                      <button
                        className={`inline-flex justify-center px-4 py-2 text-[9px] uppercase font-bold tracking-[1.7px] bg-opacity-75 text-[#724C2D] border-2 border-[#A88A60]`}
                        type="button"
                        onClick={() => {
                          closeModal()
                          setTimeout(() => {
                            setSent(false)
                          }, 1000)
                        }}
                      >
                        Schließen
                      </button>
                    </div>
                  ) : (
                    <div>
                      <form
                        className="w-full text-sm text-gray-900 mb-0"
                        name="bewertung"
                        method="post"
                        action="/danke/"
                        data-netlify="true"
                        data-netlify-honeypot="bot-field"
                        onSubmit={handleSubmit}
                      >
                        <input
                          type="hidden"
                          name="form-name"
                          value="bewertung"
                        />

                        <p hidden>
                          <label>
                            Don’t fill this out:{" "}
                            <input name="bot-field" onChange={handleChange} />
                          </label>
                        </p>
                        <h5 className="mt-10">Persönliche Daten</h5>
                        <div className="flex flex-wrap gap-4 mb-10">
                          <label className="flex-auto flex flex-col w-32">
                            <span className="block text-sm leading-5 text-slate-700">
                              Vorname *
                            </span>
                            <input
                              name="vorname"
                              onChange={handleChange}
                              type="text"
                              className="text-sm h-8 border border-slate-400 p-2 focus:outline-slate-700"
                              required
                            />
                          </label>
                          <label className="flex-auto flex flex-col w-32">
                            <span className="block text-sm leading-5 text-slate-700">
                              Nachname *
                            </span>

                            <input
                              name="nachname"
                              onChange={handleChange}
                              type="text"
                              className="text-sm h-8 border border-slate-400 p-2 focus:outline-slate-700"
                              required
                            />
                          </label>
                          <label className="flex-auto flex flex-col w-32">
                            <span className="block text-sm leading-5 text-slate-700">
                              E-Mail *
                            </span>
                            <input
                              name="email"
                              onChange={handleChange}
                              type="email"
                              className="text-sm h-8 border border-slate-400 p-2 focus:outline-slate-700"
                              required
                            />
                          </label>
                          <label className="flex-auto flex flex-col w-32">
                            <span className="block text-sm leading-5 text-slate-700">
                              Telefonnummer
                            </span>
                            <input
                              name="telefon"
                              onChange={handleChange}
                              type="tel"
                              className="text-sm h-8 border border-slate-400 p-2 focus:outline-slate-700"
                            />
                          </label>
                        </div>
                        <h5>Ihre Bewertung</h5>
                        <div className="flex flex-wrap gap-4 mb-8">
                          <label className="flex-auto flex flex-col w-64">
                            <span className="block text-sm leading-5 text-slate-700">
                              Teilgenommene Reise
                            </span>
                            <input
                              name="reise"
                              onChange={handleChange}
                              type="text"
                              className="text-sm h-8 border border-slate-400 p-2 focus:outline-slate-700"
                              placeholder="z.B. Kefalonia 1.5.-8.5.2020"
                            />
                          </label>
                          <label className="flex-auto flex flex-col w-64">
                            <span className="block text-sm leading-5 text-slate-700">
                              Bewertung
                            </span>
                            <textarea
                              name="rezension"
                              onChange={handleChange}
                              className="text-sm h-24 form-textarea border border-slate-400 p-2 focus:outline-slate-700"
                              placeholder="Schreiben Sie hier Ihre Bewertung."
                            />
                          </label>
                        </div>
                        <div className="flex gap-4 justify-end">
                          <button
                            className="justify-endinline-flex justify-center px-4 py-2 text-[9px] uppercase font-bold tracking-[1.7px] text-gray-800 border border-gray-800"
                            type="button"
                            onClick={() => {
                              closeModal()
                              setTimeout(() => {
                                setSent(false)
                              }, 1000)
                            }}
                          >
                            Schließen
                          </button>

                          <button
                            className={`inline-flex justify-center px-4 py-2 text-[9px] uppercase font-bold tracking-[1.7px] bg-[#C4AC8B] bg-opacity-75 text-[#724C2D] border-2 border-[#A88A60]`}
                            type="submit"
                          >
                            Abschicken
                          </button>
                        </div>
                      </form>
                    </div>
                  )}
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </>
  )
}
